<ui-flag culture="se"></ui-flag>
<br>
<br>
<ui-flag culture="se"
         size="small"></ui-flag>
<br>
<br>
<ui-flag culture="se"
         size="tiny"></ui-flag>
